/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeMpkRequest
 */
export interface ChangeMpkRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeMpkRequest
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeMpkRequest
     */
    newMpk: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeMpkRequest
     */
    employeeId: string;
}

/**
 * Check if a given object implements the ChangeMpkRequest interface.
 */
export function instanceOfChangeMpkRequest(value: object): value is ChangeMpkRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('newMpk' in value) || value['newMpk'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    return true;
}

export function ChangeMpkRequestFromJSON(json: any): ChangeMpkRequest {
    return ChangeMpkRequestFromJSONTyped(json, false);
}

export function ChangeMpkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeMpkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'newMpk': json['newMpk'],
        'employeeId': json['employeeId'],
    };
}

export function ChangeMpkRequestToJSON(json: any): ChangeMpkRequest {
    return ChangeMpkRequestToJSONTyped(json, false);
}

export function ChangeMpkRequestToJSONTyped(value?: ChangeMpkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'newMpk': value['newMpk'],
        'employeeId': value['employeeId'],
    };
}

